const REGISTRY_RANK: Record<string, number> = {
  REFUSED: 0,
  NEW_PATH_PENDING: 1,
  EXISTING: 2,
};
const BAND_RANK: Record<string, number> = { LOW: 0, MEDIUM: 1, HIGH: 2 };

export const canInlineApprove = (row: {
  autoApproveEligible?: boolean | null;
  kind?: string | null;
}) => !row.kind && row.autoApproveEligible === true;

export const countSaveAllBlockers = (
  rows: { autoApproveEligible?: boolean | null }[],
) => rows.filter((row) => row.autoApproveEligible !== true).length;

type SortableRow = {
  registryStatus?: unknown;
  aiBand?: unknown;
  sourceAttribute?: unknown;
};

export function sortAttributeReviewMappings<T extends SortableRow>(
  mappings: T[],
  direction: "asc" | "desc",
): T[] {
  const multiplier = direction === "asc" ? 1 : -1;
  return [...mappings].sort(
    (a, b) =>
      multiplier *
        ((REGISTRY_RANK[String(a.registryStatus)] ?? 2) -
          (REGISTRY_RANK[String(b.registryStatus)] ?? 2) ||
          (BAND_RANK[String(a.aiBand)] ?? 3) -
            (BAND_RANK[String(b.aiBand)] ?? 3)) ||
      String(a.sourceAttribute ?? "").localeCompare(
        String(b.sourceAttribute ?? ""),
      ),
  );
}
